import React, {useEffect, useState} from "react"
import {graphql, Link, useStaticQuery} from "gatsby"
import CategoriesList from "../list/categoriesList"
import SelectTags from "../list/selectTags"
import Catalog from "../content/catalog"

const BookLayout = ({children, getCategory, getTags, getSearch, getDisplayCatalog, location, isList = true}) => {
  const { allWpCategory, allWpBookTag } = useStaticQuery(graphql`
    query {
      allWpCategory(filter: {parentId: {eq: null}}) {
        nodes {
          id
          slug
          name
          wpChildren {
            nodes {
              name
              slug
              id
              parentId
            }
          }
          description
        }
      }
      allWpBookTag {
        nodes {
          id
          slug
          name
        }
      }
    }
  `)
  const categories = allWpCategory.nodes || []
  const tags = allWpBookTag.nodes || []

  const [selectedCategory, setSelectedCategory] = useState(location && location.state ? location.state.category : '')
  const [selectedCategoryObject, setSelectedCategoryObject] = useState(null)
  const [selectedTags, setSelectedTags] = useState([])
  const [searchedValue, setSearchedValue] = useState("")
  const [catalogVisible, setCatalogVisible] = useState(false)

  useEffect(() => {
    getCategory && getCategory(selectedCategory)

    setSelectedCategoryObject(categories.find(c => c.id === selectedCategory || c.wpChildren?.nodes.map(({id}) => id).includes(selectedCategory)))
  }, [selectedCategory])

  useEffect(() => {
    getTags && getTags(selectedTags)
  }, [selectedTags])

  useEffect(() => {
    getSearch && getSearch(searchedValue)
  }, [searchedValue])

  const handleDisplayCatalog = () => {
    getDisplayCatalog && getDisplayCatalog(!catalogVisible)
    setCatalogVisible(!catalogVisible)
  }

  const isSelected = id => (
    selectedCategory === id || (selectedCategoryObject?.wpChildren && selectedCategoryObject?.wpChildren.nodes.map(({id}) => id).includes(selectedCategory))
  )

  const handleClick = (id = "") => {
    setSelectedCategory(id)
  }

  return (
    <>
      <div className={`categories col-md-2 d-none ${!isList ? 'd-lg-block' : 'd-md-block'}`}>
        <CategoriesList
          categories={categories}
          selected={selectedCategory}
          onSelect={id => setSelectedCategory(selectedCategory !== id ? id : "")}
        />
      </div>
      <div className={'body'}>
        <div className={`search grid-3 grid-lg-4 ${isList ? 'col-md-9' : 'col-9'}`}>
          {isList ? (
            <>
              <div className={'input__search categories__bar d-md-none'}>
                <CategoriesList
                  categories={categories}
                  selected={selectedCategory}
                  onSelect={id => setSelectedCategory(selectedCategory !== id ? id : "")}
                />
                <i className="fas fa-sort-down" />
              </div>
              <div className={'input__search tags__bar'}>
                <SelectTags tags={tags} getValues={t => setSelectedTags(t)} />
                <i className="fas fa-sort-down" />
              </div>
              <div className={'input__search text__bar'}>
                <input type={'text'} placeholder={'Title'} onChange={({target}) => setSearchedValue(target.value)} />
                <i className="fas fa-search" />
              </div>
              {selectedCategory &&
                <div className={'sub_categories catalog d-md-none'}>
                  {selectedCategoryObject?.wpChildren.nodes.map(({id, name, slug}) => (
                    <button key={id} className={`${id === selectedCategory && 'selected'} name child`} onClick={() => handleClick(id)}>{name}</button>
                  ))}
                </div>
              }
            </>
          ) : (
            <div className={'input__search close'}>
              <Link to={'/books'} state={{category: ""}}><i className="fas fa-times" /></Link>
            </div>
          )}
          <div className={'catalog'}>
            <button
              type={'button'}
              className={`${catalogVisible && 'visible'}`}
              onClick={() => handleDisplayCatalog()}
            >
              {catalogVisible ? <i className="fas fa-times" /> : 'Catalogs'}
            </button>
          </div>
        </div>
        <div className={`books grid-2 grid-lg-4 ${isList ? 'col-md-9' : 'col-9'}`}>
          {catalogVisible ? (
            <Catalog categories={categories} />
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </>
  )
}

export default BookLayout
